import React from 'react';
import { BlogCardProps } from '@/components/card/types';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { Link } from '@/components/link/Link';
import Icon from '@/components/icon/Icon';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import clsx from 'clsx';
import { renameDomProps } from '@/utils/sanitizeDomProps';

const BlogCard: React.FC<BlogCardProps> = React.memo(
  ({ image, title, description, badge, link, className, type, ...rest }) => {
    const renamedProps = renameDomProps(rest);
    return (
      <div
        className={clsx(
          `blog-card flex h-full flex-col overflow-hidden rounded-xl border border-neutral-50 bg-white text-brand-700`,
          className,
        )}
        {...renamedProps}
      >
        <div className="relative flex w-full flex-shrink-0">
          <div className="w-full overflow-hidden">
            {image && (
              <BaseImage
                {...image}
                className="h-full w-full"
                classNameImage="w-full h-full object-cover object-top aspect-[16/10]"
                prerender
                quality={50}
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
              />
            )}
          </div>
          {/*{badge && badge?.length > 0 && (*/}
          {/*  <div className="absolute bottom-6 left-6 flex gap-2">*/}
          {/*    {badge.map((badge: BadgeProps, index: number) => (*/}
          {/*      <Badge key={index} {...badge} />*/}
          {/*    ))}*/}
          {/*  </div>*/}
          {/*)}*/}
        </div>
        <div className="flex h-full flex-col justify-between gap-4 p-6">
          <div className="flex flex-col gap-4">
            {type && (
              <span className="tag flex items-center gap-1 text-xs font-medium uppercase text-neutral-400">
                {type.icon && <Icon {...type.icon} />}
                <span>{type.title}</span>
                {type?.duration && (
                  <>
                    <span>·</span>
                    <span> {type.duration}</span>
                  </>
                )}
              </span>
            )}
            <span className="text-brand-70 text-base font-medium md:text-xl">
              {title}
            </span>
            {description && (
              <div className="text-sm md:text-base">
                <SerializeDescription description={description} />
              </div>
            )}
          </div>
          {link?.href && (
            <div className="flex self-end">
              <Link {...link}>{link.title}</Link>
            </div>
          )}
        </div>
      </div>
    );
  },
);

BlogCard.displayName = 'BlogCard';

export default BlogCard;
